import { forwardRef, type Ref, type SVGProps } from "react";
const IconCarFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28.4 13.8 26 12l-.56-4.47a4 4 0 0 0-4-3.53H10.55a4 4 0 0 0-4 3.53L6 12l-2.4 1.8A4 4 0 0 0 2 17v5a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-5a4 4 0 0 0-1.6-3.2M8.72 7.67a2 2 0 0 1 2-1.67h10.59a2 2 0 0 1 2 1.67L24 12H8ZM8 20a2 2 0 1 1 2-2 2 2 0 0 1-2 2m16 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2" />
    <path d="M18.5 8a3.5 3.5 0 0 0-3.5 3.5 4 4 0 0 0 .05.5h2a1.6 1.6 0 0 1-.09-.5 1.5 1.5 0 0 1 3 0 1.6 1.6 0 0 1-.09.5h2a4 4 0 0 0 .05-.5A3.5 3.5 0 0 0 18.5 8M5 24v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2Zm16 0v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2Z" />
  </svg>
);
const ForwardRef = forwardRef(IconCarFilledSVG);
ForwardRef.displayName = "IconCarFilled";
export { ForwardRef as IconCarFilled };
